export default __webpack_public_path__ + "static/media/txt-icon.054bed51.svg";